import {
  Avatar,
  Backdrop,
  Badge,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import Presence from "../../Assets/Presence.png";
import styled from "styled-components";
import Popover from "@mui/material/Popover";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import WorkIcon from "@mui/icons-material/Work";
import OrangeDot from "../../Assets/orangeDot.png";
import CustomIconButton from "../Button/CustomIconButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState, StartSignOut } from "../../Redux/UserSlice";
import { instance, cookies, RemoveAllCookies } from "../../Controller/Common";
import { useLocation, useNavigate } from "react-router-dom";
import TourIcon from "@mui/icons-material/Tour";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SecurityIcon from "@mui/icons-material/Security";
import HelpIcon from "@mui/icons-material/Help";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import PasswordIcon from "@mui/icons-material/Password";
import { AppNotification } from "../../Hook/AppNotification";
import { useThemes } from "../../Theme";

interface StateType {
  classRoom: {
    classroomPage: any;
    coursestatus: any;
  };
}
interface StateType {
  profileDetails: {
    editSatus: any;
    showModal: any;
  };
}

export default function Profile() {
  const theme = useThemes();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [loading, setLoading] = React.useState(false);
  const setEdit = useSelector(
    (state: StateType) => state.profileDetails.editSatus
  );
  const { coursestatus } = useSelector((state: StateType) => state.classRoom);
  const location = useLocation();
  const path = location.pathname;
  const nextPage = useSelector(
    (state: StateType) => state.classRoom.classroomPage
  );
  const notificationsLength = useSelector(
    (state: any) => state.notifications.count
  );

  const { notifications, markAsRead, fetchNotifications, handleMarkAllAsRead } =
    AppNotification();
  const handleClose = () => {
    fetchNotifications();
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!anchorEl) {
      fetchNotifications();
      setAnchorEl(event.currentTarget);
    } else {
      handleClose();
    }
  };
  const SignOut = async () => {
    try {
      setLoading(true);
      const response = await instance.post("/6D/auth/signout");
      if (response.status === 200) {
        sessionStorage.clear();
        RemoveAllCookies();
        dispatch(StartSignOut());
        navigate("/signin");
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const Profile = useSelector((state: RootState) => state.user.profile);
  const userName = useSelector((state: RootState) => state.user.userName);

  const timeAgo = (dateString: string) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} day${days !== 1 ? "s" : ""} ago`;
    } else {
      const weeks = Math.floor(diffInSeconds / 604800);
      return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    }
  };

  return (
    <NavBox>
      <CustomBox>
        <Badge
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          badgeContent=" "
          overlap="circular"
          color="success"
          sx={{
            "& .MuiBadge-badge": {
              width: 10,
              height: 10,
              minWidth: 10,
              minHeight: 10,
              borderRadius: "50%",
            },
          }}
        >
          <Avatar
            key={new Date().getTime()}
            src={`${Profile}`}
            className="BarAvatar"
          />
        </Badge>
        <Typography className="BarProfile" >
          {userName === undefined || null ? "User" : userName}
        </Typography>
      </CustomBox>
      <Box>
        <IconButton
          aria-describedby={id}
          onClick={handleClick}
          sx={{
            padding: "10px",
            marginRight: "8px",
            backgroundColor: anchorEl ? "info.main" : null,
            borderRadius: "5px",
            ":hover": {
              borderColor: "info.main",
              borderWidth: "2px",
              borderStyle: "solid",
            },
          }}
          disabled={notificationsLength === 0}
        >
          <Badge
            color="error"
            overlap="circular"
            badgeContent={notificationsLength}
          >
            <NotificationsNoneIcon
              sx={{
                color: anchorEl ? "white" : "info.main",
                width: "24px",
                height: "24px",
              }}
            />
          </Badge>
        </IconButton>
      
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={open}
        onClick={handleClose}
      >
        <Popover
          sx={{ zIndex: 11000 }}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          disableRestoreFocus
        >
          <MainBox onClick={(e) => e.stopPropagation()}>
            <TitleBox>
              <Button
                sx={{ textTransform: "none", color: "black" }}
                onClick={() => handleMarkAllAsRead()}
              >
                Mark All Read
              </Button>
            </TitleBox>
            {notifications?.map((i: any) => {
              const realTime = timeAgo(i?.createdAt);
              return (
                <ColorBox
                  theme={theme}
                  onClick={() => markAsRead(i?.ID)}
                  key={new Date().getMinutes()}
                >
                  <IconBox>
                    {i?.Title === "Password Changed Successfully" ? (
                      <PasswordIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "Application Tour Disabled" ? (
                      <TourIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "Profile Incomplete" ? (
                      <AccountCircleIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "For Your Security" ? (
                      <SecurityIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "Support Request Raised" ? (
                      <HelpIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "New Course Available!" ? (
                      <WorkspacePremiumOutlinedIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : i?.Title === "Policy Update" ||
                      i?.Title === "Scheduled Maintenance" ? (
                      <SportsSoccerIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    ) : (
                      <WorkIcon
                        sx={{
                          color: "info.main",
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    )}
                  </IconBox>
                  <NotifyBox>
                    <InfoBox>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "12px",
                          color: "#3F3F40",
                        }}
                      >
                        {i?.Title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: " #8C8C8C",
                          fontWeight: 400,
                        }}
                      >
                        {realTime}
                      </Typography>
                    </InfoBox>
                    <InfoBox>
                      <Typography
                        sx={{
                          fontSize: "10px",
                          color: " #3F3F40",
                          fontWeight: 400,
                          width: "18rem",
                        }}
                      >
                        {i?.Description}
                      </Typography>
                      <img
                        src={i.Read === "N" ? OrangeDot : Presence}
                        alt="icon"
                        width={20}
                        height={20}
                      />
                    </InfoBox>
                  </NotifyBox>
                </ColorBox>
              );
            })}
          </MainBox>
        </Popover>
      </Backdrop>
      <CustomIconButton
        variant="secondary"
        icon={LogoutIcon}
        iconSize={25}
        style={{ color: loading && "white" }}
        disable={
          (path === "/landing/classroom" && nextPage !== 1 && nextPage !== 0 && coursestatus !== "COMPLETED") ||
          (path === "/landing/profile" && setEdit === true)
        }
        onClick={() => SignOut()}
      />
      </Box>
    </NavBox>
  );
}
const NavBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  min-width: 270px;
  margin-right: 20px;
`;
const CustomBox = styled(Box)`
  display: flex;
  align-items: center;
  /* gap: 10px; */
  margin-right: 8px;
  padding: 0px 10px 0px 0px;
`;
const MainBox = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 15px;
`;
const TitleBox = styled(Box)`
  display: flex;
  justify-content: flex-end;
  padding: 10px 0 10px 10px;
`;
const ColorBox = styled(Box)<{ theme: any }>`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.light_White.whiteGrey};
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
`;
const IconBox = styled(Box)`
  display: flex;
  padding: 15px;
  justify-content: center;
  border-radius: 5px;
  background-color: #ffffff;
`;
const InfoBox = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 22rem;
  justify-content: space-between;
  align-items: center;
  padding: 3px 5px 0px 10px;
`;
const NotifyBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;
